// @ts-nocheck
import $ from 'jquery';
import DateFormat from 'dateformat';

import NotRunning from '../images/NotRunning.png';
import Running from '../images/Running.png';

const gensetFormatter = {
    gensetSwitchFormatterImg: (params) => {
        if (params.data != null && params.data != undefined) {
            if (params.data.IgnitionOn != null && params.data.IgnitionOn != undefined) {
                if (params.data.IgnitionOn.toString().toUpperCase().trim() == "TRUE")
                    return '<div class="power-onbg"><span class="fa fa-power-off power-icon"></span></div>';
                else if (params.data.IgnitionOn.toString().toUpperCase().trim() == "FALSE")
                    return '<div class="power-offbg"><span class="fa fa-power-off power-icon"></span></div>';
                else
                    return '';
            }
            //return params.value;
        }

        return '';
    },

    gensetSwitchSorting: (params) => {
        if (params.data != null && params.data != undefined) {
            if (params.data.IgnitionOn != null && params.data.IgnitionOn != undefined) {
                if (params.data.IgnitionOn.toString().toUpperCase().trim() == "TRUE")
                    return "1";
                else if (params.data.IgnitionOn.toString().toUpperCase().trim() == "FALSE")
                    return "0"
                else
                    return "2";
            }
        }

        return "2";
    },

    gensetSwitchFormatterImgForFilter: (params) => {
        if (params.data != null && params.data != undefined) {
            if (params.data.IgnitionOn != null && params.data.IgnitionOn != undefined) {
                if (params.data.IgnitionOn.toString().toUpperCase().trim() == "TRUE")
                    return 'ON';
                else if (params.data.IgnitionOn.toString().toUpperCase().trim() == "FALSE")
                    return 'OFF';
                else
                    return '';
            }
            //return params.value;
        }

        return '';
    },

    gensetRunningFormatter: (params) => {
        if (params.data != null && params.data != undefined) {
            if (params.data.HasOilPressureSwitch != null && params.data.GensetRunning != null) {
                if (params.data.HasOilPressureSwitch.toString().toUpperCase().trim() == "TRUE") {

                    var element = document.createElement("span");
                    element.className = "reefer-alert";
                    var imageElement = document.createElement("img");

                    if (params.data.OEMTypeCD != null && params.data.OEMTypeCD.toString().toUpperCase().trim() == "C") {
                        return '';
                    }
                    else {
                        if (params.data.GensetRunning.toString().toUpperCase().trim() == "0" || params.data.GensetRunning.toString().toUpperCase().trim() == "FALSE")
                            imageElement.src = NotRunning; //No
                        else if (params.data.GensetRunning.toString().toUpperCase().trim() == "1" || params.data.GensetRunning.toString().toUpperCase().trim() == "TRUE")
                            imageElement.src = Running; //Yes
                        else
                            return '';
                        element.appendChild(imageElement);
                        return element;
                    }
                }
                else
                    return '';
            }
            else
                return '';
        }
        else
            return '';
    },

    EngineSorting: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.HasOilPressureSwitch != null && params.data.GensetRunning != null) {
                if (params.data.HasOilPressureSwitch.toString().toUpperCase().trim() == "TRUE") {
                    if (params.data.OEMTypeCD != null && params.data.OEMTypeCD.toString().toUpperCase().trim() == "C") {
                        return "2";
                    }
                    else {
                        if (params.data.GensetRunning.toString().toUpperCase().trim() == "0" || params.data.GensetRunning.toString().toUpperCase().trim() == "FALSE")
                            return "0";
                        else if (params.data.GensetRunning.toString().toUpperCase().trim() == "1" || params.data.GensetRunning.toString().toUpperCase().trim() == "TRUE")
                            return "1";
                        else
                            return "2";
                    }
                }
                else
                    return "2";
            }
            return "2";
        }
    },

    gensetRunningFormatterForFilter: (params) => {
        var title = "";
        if (params.data != null && params.data != undefined) {
            if (params.data.HasOilPressureSwitch != null && params.data.GensetRunning != null) {
                if (params.data.HasOilPressureSwitch.toString().toUpperCase().trim() == "TRUE") {
                    if (params.data.OEMTypeCD != null && params.data.OEMTypeCD.toString().toUpperCase().trim() == "C") {
                        title = '';
                    }
                    else {
                        if (params.data.GensetRunning.toString().toUpperCase().trim() == "0" || params.data.GensetRunning.toString().toUpperCase().trim() == "FALSE")
                            title = "Not Running"; //No
                        else if (params.data.GensetRunning.toString().toUpperCase().trim() == "1" || params.data.GensetRunning.toString().toUpperCase().trim() == "TRUE")
                            title = "Running"; //Yes
                        else
                            title = '';
                    }
                }
                else
                    title = '';
            }
            else
                title = '';
        }
        else
            title = '';

        return title;
    },

    oemTypeFormatterGensetForFilter: (params) => {
        var oemType = '';
        if (params.data != null && params.data != undefined && params.data.OEMTypeCD != null && params.data.OEMTypeCD != undefined) {
            switch (params.data.OEMTypeCD.toString().toUpperCase().trim()) {
                case "C":
                    oemType = "CAR";
                    break;
                case "D":
                    oemType = "DKN";
                    break;
                case "S":
                    oemType = "SC";
                    break;
                case "T":
                    oemType = "TK";
                    break;
                case "G":
                    oemType = "GMK";
                    break;
                case "TA":
                    oemType = "TLR";
                    break;
                case "U":
                    oemType = "UNK";
                    break;
                case "CARRIER":
                    oemType = "CAR";
                    break;
                case "DAIKIN":
                    oemType = "DKN";
                    break;
                case "STARCOOL":
                    oemType = "SC";
                    break;
                case "THERMOKING":
                    oemType = "TK";
                    break;
                case "GENMARK":
                    oemType = "GMK";
                    break;
                case "TAYLOR":
                    oemType = "TLR";
                    break;
                case "UNKNOWN":
                    oemType = "UNK";
                    break;
                default:
                    oemType = '-NA-';
            }
        }
        else oemType = "-NA-";
        return oemType;
    },

    fuelSensorTrace: (params) => {

        if (params.data != null && params.data != undefined && params.data != '') {

            if (params.data.HasFuelSensor != null && params.data.HasFuelSensor != undefined
                && params.data.HasFuelSensor === false) {
                return "No Sensor";
            }
            else {
                if (params.data.FuelLevelQualifier == "" || params.data.FuelLevelQualifier == null) {
                    return "-NA-";
                }
                else {

                    if (params.data.FuelLevelQualifier == "C" || params.data.FuelLevelQualifier == "N" ||
                        params.data.FuelLevelQualifier == "S" || params.data.FuelLevelQualifier == "U") {
                        return params.data.FuelLevelQualifierDesc;
                    }
                    else {
                        return "Present";
                    }

                }
            }
        }
        return '-NA-';
    },

    FuelSensorSorting: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.HasFuelSensor != null && params.data.HasFuelSensor != undefined
                && params.data.HasFuelSensor === false) {
                return 0;
            }
            else {
                if (params.data.FuelLevelQualifier == "" || params.data.FuelLevelQualifier == null) {
                    return -1;
                }
                else {
                    if (params.data.FuelLevelQualifier == "C") return 1;
                    else if (params.data.FuelLevelQualifier == "N") return 2;
                    else if (params.data.FuelLevelQualifier == "S") return 4;
                    else if (params.data.FuelLevelQualifier == "U") return 5;
                    else return 3;
                }
            }
        }
        return -1;
    },

    FuelSensorQuickFilterFormatter: (param) => {
        if (param != null && param != undefined && param != '') {
            switch (param.value.toString()) {
                case "0": return "No Sensor";
                case "1": return "Config Error";
                case "2": return "Not Configured";
                case "3": return "Present";
                case "4": return "Sensor Error";
                case "5": return "Unknown";
                default:
                    return "*No Fuel Sensor";
            }
        }
        return "*No Fuel Sensor";    
    },

    fillLevelGalTrace: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.HasFuelSensor != null && params.data.HasFuelSensor != undefined
                && params.data.HasFuelSensor === false) {
                return "No Sensor";
            }
            else {
                var tempRoundingValue = "2";
                if (params.data.FuelLevelQualifier != null && ((params.data.FuelLevelQualifier == 'A') ||
                    (params.data.FuelLevelQualifier == 'P'))) {
                    return (params.data.FuelLevel != null) ? parseFloat(params.data.FuelLevel.toFixed(parseInt(tempRoundingValue))) : "-NA-";
                }
                else {
                    return params.data.FuelLevelQualifierDesc;
                }
            }
        }
        return '-NA-';
    },

    FuelLevelGalSorting: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.HasFuelSensor != null && params.data.HasFuelSensor != undefined
                && params.data.HasFuelSensor === false) {
                return -6;
            }
            else {
                var tempRoundingValue = "2";
                if (params.data.FuelLevelQualifier != null && ((params.data.FuelLevelQualifier == 'A') || (params.data.FuelLevelQualifier == 'P'))) {
                    return (params.data.FuelLevel != null) ? parseFloat(params.data.FuelLevel.toFixed(parseInt(tempRoundingValue))) : -7;
                }
                else {
                    if (params.data.FuelLevelQualifier != null) {
                        if (params.data.FuelLevelQualifier == "C") return -5;
                        else if (params.data.FuelLevelQualifier == "N") return -4;
                        else if (params.data.FuelLevelQualifier == "S") return -3;
                        else if (params.data.FuelLevelQualifier == "U") return -1;
                        else return -2;
                    }
                }
            }
            return -7;
        }
    },

    fillLevelTrace: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {

            if (params.data.HasFuelSensor != null && params.data.HasFuelSensor != undefined
                && params.data.HasFuelSensor === false) {
                return "No Sensor";
            }
            else {
                if (params.data.HasFuelSensor != null && params.data.HasFuelSensor.toString().toUpperCase().trim() == "TRUE") {
                    if (params.data.FuelLevelQualifier != null && ((params.data.FuelLevelQualifier == 'A') || (params.data.FuelLevelQualifier == 'P'))) {
                        if (params.data.FuelLevelTierNumber != null) {
                            var element = document.createElement("span");
                            element.className = "reefer-alert";
                            var imageElement = document.createElement("img");
                            imageElement.src = "../images/FuelFractionImages/" + params.data.FractionDisplayGif;
                            element.appendChild(imageElement);
                            return element;
                        }
                        else {
                            if (params.data.FuelLevelPct != null) {
                                var tempRoundingValue = "2";
                                return parseFloat(params.data.FuelLevelPct.toFixed(parseInt(tempRoundingValue))) + " %";
                            }
                            else {
                                return '<span title="Fuel Reading Unavailable">Fuel Reading Unavailable</span>';
                            }
                        }
                    }
                    else {
                        if (params.data.FuelLevelQualifier == "S")
                            return '<span title="Sensor Error">Sensor Error</span>';
                        else
                            return params.data.FuelLevelQualifierDesc;
                    }
                }
                else
                    return "-NA-";
            }

        }
        else
            return '-NA-';
    },

    FuelLevelSorting: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.HasFuelSensor != null && params.data.HasFuelSensor != undefined
                && params.data.HasFuelSensor === false) {
                return -7;
            }
            else {
                if (params.data.HasFuelSensor != null && params.data.HasFuelSensor.toString().toUpperCase().trim() == "TRUE") {

                    if (params.data.FuelLevelQualifier != null && ((params.data.FuelLevelQualifier == 'A') || (params.data.FuelLevelQualifier == 'P'))) {
                        if (params.data.FuelLevelTierNumber != null) {
                            return params.data.FuelLevelTierNumber;
                        }
                        else {
                            if (params.data.FuelLevelPct != null) {
                                var tempRoundingValue = "2";
                                return parseFloat(params.data.FuelLevelPct.toFixed(parseInt(tempRoundingValue)));
                            }
                            else return -5;
                        }
                    }
                    else {
                        if (params.data.FuelLevelQualifier == "C") return -6;
                        else if (params.data.FuelLevelQualifier == "N") return -4;
                        else if (params.data.FuelLevelQualifier == "S") return -3;
                        else if (params.data.FuelLevelQualifier == "U") return -1;
                        else return -2;
                    }
                }
            }
        }

        return -8;
    },

    FuelLevelGalQuickFilterFormatter: (param) => {
        if (param != null && param != undefined && param != '') {
            if (param.value < 0) {
                switch (param.value.toString()) {
                case "-6": return "No Sensor";
                case "-5": return "Config Error";
                case "-4": return "Not Configured";
                case "-3": return "Sensor Error";
                case "-2": return "Sensor Error";
                case "-1": return "Unknown";
                default:
                    return "*No Fuel Level (gal.)";
            }
        }
        else
                return param.value;
        }
    },

    FuelLevelQuickFilterFormatter: (params) => {
        if (params != null && params != undefined && params != '') {
            if (params.value < 0) {
                switch (params.toString()) {
                    case "-7": return "No Sensor";
                    case "-6": return "Config Error";
                    case "-5": return "Fuel Reading Unavailable";
                    case "-4": return "Not Configured";
                    case "-3": return "Sensor Error";
                    case "-2": return "Sensor Error";
                    case "-1": return "Unknown";
                    default:
                        return "*No Fuel Level";
                }
            }
            else {
                var image: any = params.value;
                if (image > 17)
                    return params.value;
                else
                    image = params.value - 1;

                if (image == 0)
                    image = "E";
                else if (image == 16)
                    image = "F";

                var element = document.createElement("span");
                element.className = "reefer-alert";
                var imageElement = document.createElement("img");
                imageElement.src = "../images/FuelFractionImages/" + image + ".png";
                element.appendChild(imageElement);
                return element;
            }

        }        
    },

    YesNoConverterForFilter: (params) => {
        if (params.data != null && params.data != undefined && params.data != '' && params.data.HasOilPressureSwitch != null && params.data.HasOilPressureSwitch != undefined && params.data.HasOilPressureSwitch != '') {
            if (params.data.HasOilPressureSwitch.toString().toUpperCase().trim() == "0" || params.data.HasOilPressureSwitch.toString().toUpperCase().trim() == "FALSE") {
                return "No";
            }
            else if (params.data.HasOilPressureSwitch.toString().toUpperCase().trim() == "1" || params.data.HasOilPressureSwitch.toString().toUpperCase().trim() == "TRUE") {
                return "Yes";
            }
            else {
                return "-NA-";
            }
        }
        return "-NA-";
    },

    gensetSpeedValueFormatter: (params) => {
        var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;
        var speedUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).SpeedUnitCd.trim();
        if (params.value != '-NA-') {
            if (speedUnitCd.toLowerCase() == "kmh") {
                var param = params.value;
                return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
            }
            else {
                var tempVal = parseFloat(params.value);
                var param1 = (tempVal / 1.609344);
                return parseFloat(param1.toFixed(parseInt(tempRoundingValue)));
            }
        }
        else
            return '-NA-';
    }
}

export default gensetFormatter;